import { create } from 'zustand';

interface GlobalState {
  isLoading: boolean;
  setLoading: (isLoading: boolean) => void;
}

export const useGlobalStore = create<GlobalState>((set) => ({
  isLoading: false,
  setLoading: (isLoading) => set({ isLoading }),
}));
